import { render, staticRenderFns } from "./Geo-Tagging.vue?vue&type=template&id=5da77295&"
import script from "./Geo-Tagging.vue?vue&type=script&lang=ts&"
export * from "./Geo-Tagging.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports